/* eslint-disable no-console */ /* eslint-disable no-console */
<template>
  <div>
    <Card style="height: 90vh; overflow: scroll;" v-if="user.role.type == 'admin'">
      <Row :gutter="16" type="flex" justify="center" style="margin-right: 0px; margin-left: 0px;">
        <Col :md="10" :xs="24">
          <a
            :href="
              showData.productId
                ? `https://www.amazon.com/dp/${showData.productId}`
                : showData.previewImg
            "
            target="_blank"
          >
            <Tooltip
              placement="left"
              max-width="700"
              theme="light"
              transfer
              :disabled="showData.previewImg === undefined"
            >
              <img
                :style="{
                backgroundColor: showData.primaryColor ? Object.values(colors).filter(
                  color => color.name === showData.primaryColor
                )[0].hex : 'white'
              }"
                width="100%"
                :src="showData.thumbnailImg || defaultImg"
              />
              <div slot="content">
                <img
                  v-if="showData.previewImg"
                  :style="{
                    backgroundColor: showData.primaryColor ? Object.values(colors).filter(
                      color => color.name === showData.primaryColor
                    )[0].hex : 'white'
                  }"
                  height="600px"
                  :src="showData.previewImg"
                />
              </div>
            </Tooltip>
          </a>
          <div
            v-if="!showData.thumbnailImg"
            style="position: absolute; top: 75px; left: 0; right: 0; margin: auto; text-align: center;"
          >
            <div
              v-if="showData.productType !== 'STANDARD_PULLOVER_HOODIE-US'"
              style="margin: 0px 67px; border: 1px dashed"
            >
              <strong>
                4500px
                <br />x
                <br />5400px
              </strong>
            </div>
            <div v-else style="margin: 0px 67px; border: 1px dashed">
              <strong>
                4500px
                <br />x
                <br />4050px
              </strong>
            </div>
          </div>
          <Row type="flex" justify="center" style="text-align: center;">
            <Col :xs="24">
              <div v-if="showData.designUrl === ''">
                <p style="display: inline-block;">
                  {{
                  showData.category +
                  "_" +
                  showData.number +
                  (showData.cloneNumber ? "_" + showData.cloneNumber : "")
                  }}
                </p>
              </div>
              <div v-else>
                <a style="display: inline-block;" :href="showData.designUrl">
                  <Icon type="md-download" />
                  {{
                  showData.category +
                  "_" +
                  showData.number +
                  (showData.cloneNumber ? "_" + showData.cloneNumber : "")
                  }}
                </a>
              </div>
            </Col>
          </Row>
        </Col>
        <Col :md="14" :xs="24">
          <Row style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;">
            <Col :md="12" :xs="24">
              <p>Design status:</p>
              <Select
                v-model="showData.designStatus"
                transfer
                style="width: 95%;"
                @on-change="saveData()"
              >
                <Option
                  v-for="(item, index) in designStatusData"
                  :value="item.designStatus"
                  :key="index"
                >{{ item.name }}</Option>
              </Select>
            </Col>
            <Col :md="12" :xs="24">
              <p>Image status:</p>
              <Select
                v-model="showData.imgStatus"
                transfer
                style="width: 95%;"
                @on-change="saveData()"
              >
                <Option
                  v-for="(item, index) in imgStatusData"
                  :value="item.imgStatus"
                  :key="index"
                >{{ item.name }}</Option>
              </Select>
            </Col>
          </Row>
          <Row
            v-if="showData.productType === 'STANDARD_TSHIRT-US'"
            style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;"
          >
            <Col :md="3" :xs="3" v-for="(color, hex) in colors" :key="hex">
              <Tooltip :content="color.name" placement="bottom" :delay="800">
                <ColorSelector
                  :color="hex"
                  :name="hex"
                  :checked="color.checked"
                  @on-change="changeColor"
                  :disabled="showData.designStatus !== 'new'"
                ></ColorSelector>
              </Tooltip>
            </Col>
            <Col :md="3" :xs="3">
              <Button
                type="primary"
                shape="circle"
                icon="ios-color-fill"
                @click="fastSelectColor('light')"
              ></Button>
            </Col>
            <Col :md="3" :xs="3">
              <Button
                type="primary"
                shape="circle"
                icon="ios-color-fill-outline"
                @click="fastSelectColor('dark')"
              ></Button>
            </Col>
          </Row>
          <Row v-else style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;">
            <Col :md="3" :xs="3" v-for="(color, hex) in w_colors" :key="hex">
              <Tooltip :content="color.name" placement="bottom" :delay="800">
                <ColorSelector
                  :color="hex"
                  :name="hex"
                  :checked="color.checked"
                  @on-change="changeColor"
                  :disabled="showData.designStatus !== 'new'"
                ></ColorSelector>
              </Tooltip>
            </Col>
          </Row>
          <Row
            v-if="showData.productType === 'STANDARD_TSHIRT-US'"
            style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;"
          >
            <Col :md="3">Type:</Col>
            <CheckboxGroup v-model="showData.type" @on-change="saved = false" align="center">
              <Checkbox label="Men" :disabled="showData.designStatus !== 'new'"></Checkbox>
              <Checkbox label="Women" :disabled="showData.designStatus !== 'new'"></Checkbox>
              <Checkbox label="Youth" :disabled="showData.designStatus !== 'new'"></Checkbox>
            </CheckboxGroup>
          </Row>
          <Row style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;">
            <Col :md="12">
              <p>Price:</p>
              <Input
                :disabled="showData.designStatus !== 'new'"
                v-model="showData.price"
                @on-change="saved = false"
                prefix="logo-usd"
                placeholder="Enter number"
                style="width: 120px"
              />
            </Col>
            <Col :md="12">
              <p>Score:</p>
              <Select
                :disabled="showData.designStatus !== 'new'"
                v-model="showData.designScore"
                @on-change="saved = false"
                prefix="md-clock"
                style="width: 150px"
              >
                <Option
                  v-for="item in scoreList"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
            </Col>
          </Row>
          <Row style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;">
            <RadioGroup v-model="showData.primaryColor" @on-change="saved = false">
              <Radio
                :disabled="showData.designStatus !== 'new'"
                v-for="color in selectedColors"
                :key="color.name"
                :label="color.name"
              >
                <div>
                  <Tooltip :content="color.name" placement="top" :delay="800">
                    <ColorSelector
                      :color="color.hex"
                      :name="color.hex"
                      :disabled="true"
                      style="margin-left: -8px;"
                    ></ColorSelector>
                  </Tooltip>
                </div>
              </Radio>
            </RadioGroup>
          </Row>
        </Col>
      </Row>
      <Divider style="margin: 15px 0"></Divider>
      <Row :gutter="16" style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;">
        <Col :md="19" :xs="19">
          <Input
            :disabled="showData.designStatus !== 'new'"
            @on-change="saved = false; debounce(() => {validateKeywords('brand')}, 500)()"
            v-model="showData.brand"
            placeholder="Brand name"
            :maxlength="50"
          ></Input>
          <p v-if="this.errorBrand" class="error-message">
            {{this.brandErrorMessage}}
            <a v-for="tm in brandTM" target="_blank" :href="`http://tsdr.uspto.gov/#caseNumber=${tm[0]}&caseType=SERIAL_NO&searchType=statusSearch`">
              {{tm[1]}},
            </a>
          </p>
        </Col>
        <Col :md="5" :xs="5">
          <p @click="copyToClipboard(showData.brand)" align="right" style="margin-top: 5px;">
            <Icon type="md-copy" />
            Brand ({{ showData.brand.length }}):
          </p>
        </Col>
      </Row>
      <Row :gutter="16" style="margin-right: 0px; margin-left: 0px; margin-bottom: 5px;">
        <Col :md="19" :xs="19">
          <Input
            :disabled="showData.designStatus !== 'new'"
            v-model="showData.title"
            placeholder="Design title"
            :maxlength="60"
            @on-change="save = false; debounce(() => {validateKeywords('title')}, 500)()"
          ></Input>
          <p v-if="this.errorTitle" class="error-message">
            {{this.titleErrorMessage}}
            <a v-for="tm in titleTM" target="_blank" :href="`http://tsdr.uspto.gov/#caseNumber=${tm[0]}&caseType=SERIAL_NO&searchType=statusSearch`">
              {{tm[1]}},
            </a>
          </p>
        </Col>
        <Col :md="5" :xs="5">
          <p @click="copyToClipboard(showData.title)" align="right" style="margin-top: 5px;">
            <Icon type="md-copy" />
            Title ({{ showData.title.length }}):
          </p>
        </Col>
      </Row>
      <Row :gutter="16" style="margin-right: 0px; margin-left: 0px;">
        <Col :md="12" :xs="24">
          <div>

              <p @click="copyToClipboard(showData.kpf1)">
                <Icon type="md-copy" />
                Key product features 1 ({{ showData.kpf1.length }}):
              </p>

            
            <Input
              :disabled="showData.designStatus !== 'new'"
              @on-change="saved = false; debounce(() => {validateKeywords('kpf1')}, 500)()"
              v-model="showData.kpf1"
              style="width: 260px"
              :autosize="{ minRows: 3, maxRows: 9 }"
              placeholder="Key product features"
              :maxlength="256"
              type="textarea"
            ></Input>
            <p v-if="this.errorKpf1" class="error-message">
              {{this.kpf1ErrorMessage}}
              <a v-for="tm in kpf1TM" target="_blank" :href="`http://tsdr.uspto.gov/#caseNumber=${tm[0]}&caseType=SERIAL_NO&searchType=statusSearch`">
                {{tm[1]}},
              </a>
            </p>
          </div>
        </Col>
        <Col :md="12" :xs="24">
          <div>

            <p @click="copyToClipboard(showData.kpf2)">
              <Icon type="md-copy" />
              Key product features 2 ({{ showData.kpf2.length }}):
            </p>

            <Input
              :disabled="showData.designStatus !== 'new'"
              @on-change="saved = false; debounce(() => {validateKeywords('kpf2')}, 1000)()"
              v-model="showData.kpf2"
              style="width: 260px"
              placeholder="Key product features"
              :autosize="{ minRows: 3, maxRows: 9 }"
              :maxlength="256"
              type="textarea"
            ></Input>
            <p v-if="this.errorKpf2" class="error-message">
              {{this.kpf2ErrorMessage}}
              <a v-for="tm in kpf2TM" target="_blank" :href="`http://tsdr.uspto.gov/#caseNumber=${tm[0]}&caseType=SERIAL_NO&searchType=statusSearch`">
                {{tm[1]}},
              </a>
            </p>
          </div>
        </Col>
      </Row>
      <Divider style="margin: 15px 0"></Divider>
      <Row :gutter="16" style="margin-right: 0px; margin-left: 0px;">
        <Col>
          <strong>Yêu cầu:</strong>
          <Tooltip content="Edit requirement" placement="top" theme="light" :delay="1000">
            <Button
              shape="circle"
              icon="md-create"
              @click="editRequirement()"
              style="margin-left: 5px;"
            ></Button>
          </Tooltip>
          <Tooltip content="Get keywords from amazon" placement="top" theme="light" :delay="1000">
            <Button
              shape="circle"
              icon="ios-cloud-download"
              @click="getKeywordsFromRequirement()"
              style="margin-left: 5px;"
            ></Button>
          </Tooltip>
          <Input
            v-if="editableRequirement"
            v-model="showData.requirement"
            style="width: 100%"
            placeholder="Yêu cầu"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :maxlength="2000"
            type="textarea"
            @on-change="saved = false"
          ></Input>
          <vue-markdown
            v-else
            :prerender="findLinkMarkdown"
            :anchorAttributes="{ target: '_blank' }"
            :source="showData.requirement"
            :html="false"
          ></vue-markdown>
        </Col>
      </Row>
      <Divider style="margin: 15px 0"></Divider>
      <Row :gutter="16" style="margin-right: 0px; margin-left: 0px;">
        <Col>
          <strong>Ghi chú:</strong>
          <vue-markdown
            :prerender="findLinkMarkdown"
            :anchorAttributes="{ target: '_blank' }"
            :source="showData.note"
            :html="false"
          ></vue-markdown>
        </Col>
      </Row>
    </Card>
    <div style="position: fixed; bottom: 0; right: 0;" v-if="user.role.type == 'admin'">
      <Row
        :gutter="16"
        type="flex"
        justify="center"
        style="margin-right: 0px; margin-left: 0px; margin-top: 0px;"
      >
        <ButtonGroup>
          <Button :type="'success'" @click="clone()">Clone</Button>
          <Button :type="'primary'" :disabled="saved" @click="saveData()">Save</Button>
          <Button
            :type="'success'"
            :disabled="showData.designStatus !== 'new' ? true : false"
            @click="
              showData.designStatus = 'ready';
              saveData();
            "
          >Up</Button>
          <Button
            :type="(titleTM.length || brandTM.length || kpf1TM.length || kpf2TM.lenght) ? 'warning' : 'dashed'"
            @click="() => {validateKeywords('brand'); validateKeywords('title'); validateKeywords('kpf1'); validateKeywords('kpf2')}"
          >TM</Button>
          <Button :type="'error'" @click="modal = true">Delete</Button>
          <Modal v-model="modal" width="360">
            <p slot="header" style="color:#f60;text-align:center">
              <Icon type="ios-information-circle"></Icon>
              <span>Delete confirmation</span>
            </p>
            <div style="text-align:center">
              <p>After this design is deleted, you can't see it in the list.</p>
              <p>Will you delete it?</p>
            </div>
            <div slot="footer">
              <Button
                type="error"
                size="large"
                long
                @click="
                  showData.deleted = true;
                  saveData();
                  modal = false;
                "
              >Delete</Button>
            </div>
          </Modal>
        </ButtonGroup>
      </Row>
    </div>
    <Card style="height: 90vh; overflow: scroll;" v-if="user.role.type == 'designer'">
      <Row :gutter="16" type="flex" justify="center" style="margin-right: 0px; margin-left: 0px;">
        <Col :md="24" :xs="24" style="text-align: center">
          <div v-if="!showData.thumbnailImg">
            <div v-if="showData.productType !== 'STANDARD_PULLOVER_HOODIE-US'">
              <p style="color: red; font-style: italic;">* Size yêu cầu: 4500px x 5400px</p>
            </div>
            <div v-else>
              <p style="color: red; font-style: italic;">* Size yêu cầu: 4500px x 4050px</p>
            </div>
          </div>
          <img
            :style="{
              backgroundColor: showData.primaryColor ? Object.values(colors).filter(
                color => color.name === showData.primaryColor
              )[0].hex : 'black'
            }"
            :width="previewWidth"
            :src="showData.previewImg || showData.thumbnailImg || defaultImg"
            @click="previewWidth = (previewWidth == '100%' ? '40%' : '100%')"
          />
          <Row type="flex" justify="center" style="text-align: center;">
            <Col :xs="24">
              <p style="display: inline-block;">
                <strong>
                  {{
                  showData.category +
                  "_" +
                  showData.number +
                  (showData.cloneNumber ? "_" + showData.cloneNumber : "")
                  }}
                </strong>
              </p>
              <div style="text-align: left;"></div>
            </Col>
            <Col :xs="24">
              <Poptip trigger="hover">
                Loại: {{ (scoreList.filter(item => item.value === showData.designScore)[0]) ? scoreList.filter(item => item.value === showData.designScore)[0].label : "" }} +{{ showData.designScore }}đ
                <div slot="content">Điểm thưởng khi hoàn thành mẫu</div>
              </Poptip>
            </Col>
          </Row>
        </Col>
        <br />
        <Col :md="15" :xs="24" style="margin-top: 20px; text-align: center;">
          <Row v-if="showData.productType === 'STANDARD_TSHIRT-US'">
            <RadioGroup v-model="showData.primaryColor">
              <Radio v-for="color in colors" :key="color.name" :label="color.name">
                <div>
                  <Tooltip :content="color.name" placement="top" :delay="800">
                    <ColorSelector
                      :color="color.hex"
                      :name="color.hex"
                      :disabled="true"
                      style="margin-left: -8px;"
                      @click.native="showData.primaryColor = color.name"
                    ></ColorSelector>
                  </Tooltip>
                </div>
              </Radio>
            </RadioGroup>
          </Row>
          <Row v-else>
            <RadioGroup v-model="showData.primaryColor">
              <Radio v-for="color in w_colors" :key="color.name" :label="color.name">
                <div>
                  <Tooltip :content="color.name" placement="top" :delay="800">
                    <ColorSelector
                      :color="color.hex"
                      :name="color.hex"
                      :disabled="true"
                      style="margin-left: -8px;"
                      @click.native="showData.primaryColor = color.name"
                    ></ColorSelector>
                  </Tooltip>
                </div>
              </Radio>
            </RadioGroup>
          </Row>
        </Col>
        <Input
          v-model="showData.designUrl"
          prefix="ios-image-outline"
          placeholder="File design path"
          style="width: 260px"
          readonly
        />
      </Row>
      <Divider style="margin: 15px 0"></Divider>
      <Row>
        <Col :md="24" :xs="24">
          <strong>Yêu cầu:</strong>
          <vue-markdown
            :prerender="findLinkMarkdown"
            :anchorAttributes="{ target: '_blank' }"
            :source="showData.requirement"
            :html="false"
          ></vue-markdown>
        </Col>
      </Row>
      <Divider style="margin: 15px 0"></Divider>
      <Row>
        <Col :md="24" :xs="24">
          <strong>Ghi chú:</strong>
          <Tooltip content="Edit note" placement="top" theme="light" :delay="1000">
            <Button shape="circle" icon="md-create" @click="editNote()" style="margin-left: 5px;"></Button>
          </Tooltip>
          <Input
            v-if="editableNote"
            v-model="showData.note"
            style="width: 100%"
            placeholder="Ghi chú"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :maxlength="2000"
            type="textarea"
          ></Input>
          <vue-markdown
            v-else
            :prerender="findLinkMarkdown"
            :anchorAttributes="{ target: '_blank' }"
            :source="showData.note"
            :html="false"
          ></vue-markdown>
        </Col>
      </Row>
    </Card>
    <div
      v-if="showData.imgStatus !== 'confirmed'"
      style="visibility:hidden; opacity:0"
      id="dropzone"
    >
      <div id="textnode">Drop files to add data.</div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { colors as COLORS, winter_colors as W_COLORS } from '@/helpers'
import VueMarkdown from 'vue-markdown'
import ColorSelector from './ColorSelector.vue'

export default {
  components: {
    ColorSelector,
    VueMarkdown
  },
  props: {
    data: {}
  },
  data() {
    return {
      designStatusData: [
        { name: 'New', designStatus: 'new' },
        { name: 'Ready', designStatus: 'ready' },
        { name: 'Uploaded', designStatus: 'uploaded' },
        { name: 'Live', designStatus: 'live' },
        { name: 'Rejected', designStatus: 'rejected' },
        { name: 'Removed', designStatus: 'removed' }
      ],
      imgStatusData: [
        { name: 'None', imgStatus: 'none' },
        { name: 'Uploaded', imgStatus: 'uploaded' },
        { name: 'Confirmed', imgStatus: 'confirmed' },
        { name: 'Rejected', imgStatus: 'rejected' }
      ],
      user: {},
      saved: true,
      modal: false,
      oldData: {},
      selectedColors: [],
      accounts: [],
      cloneSelect: '',
      cloneList: [],
      showData: {},
      editableRequirement: false,
      editableNote: false,
      previewWidth: '40%',
      scoreList: [
        {
          value: 4,
          label: 'Bóc nền'
        },
        {
          value: 5,
          label: 'Duplicate'
        },
        {
          value: 8,
          label: 'Clone'
        },
        {
          value: 10,
          label: 'New không hình'
        },
        {
          value: 20,
          label: 'New hình'
        }
      ],
      colors: JSON.parse(JSON.stringify(COLORS)),
      w_colors: JSON.parse(JSON.stringify(W_COLORS)),
      savedTitle: null,
      errorBrand: false,
      errorTitle: false,
      errorKpf1: false,
      errorKpf2: false,
      brandErrorMessage: null,
      titleErrorMessage: null,
      kpf1ErrorMessage: null,
      kpf2ErrorMessage: null,
      brandTM: [],
      titleTM: [],
      kpf1TM: [],
      kpf2TM: [],
      existTitle: false,
      debounceTimeout: null
    }
  },
  created() {
    this.user = this.$store.state.auth.user

    this.showData = JSON.parse(JSON.stringify(this.data))

    this.savedTitle = this.showData.title

    window.addEventListener('dragenter', this.dragenterFunc)

    window.addEventListener('dragleave', this.dragleaveFunc)

    window.addEventListener('dragover', this.dragoverFunc)

    window.addEventListener('drop', this.dropFunc)
  },
  mounted() {
    // console.log('data: ', this.data)
    if (this.showData.productType === 'STANDARD_TSHIRT-US') {
      for (const key in this.colors) {
        if (this.showData.colors.includes(this.colors[key].name)) {
          this.colors[key].checked = true
          if (this.showData.primaryColor == this.colors[key].name) {
            this.colors[key].primary = true
          }
          this.selectedColors.push(this.colors[key])
        }
      }
    } else {
      for (const key in this.w_colors) {
        if (this.showData.colors.includes(this.w_colors[key].name)) {
          this.w_colors[key].checked = true
          if (this.showData.primaryColor == this.w_colors[key].name) {
            this.w_colors[key].primary = true
          }
          this.selectedColors.push(this.w_colors[key])
        }
      }
    }

    this.accounts = this.$store.state.accounts
    // this.$bind('accounts', db.collection('accounts'))
  },
  computed: {
    account: {
      get: function() {
        if (this.showData.account) return this.showData.account.id
        else return ''
      },
      set: function(newValue) {
        for (let i = 0; i < this.accounts.length; i++) {
          if (this.accounts[i].id == newValue) {
            this.showData.account = this.accounts[i]
            break
          }
        }
      }
    },
    defaultImg: function() {
      if (this.showData.productType === 'STANDARD_TSHIRT-US') {
        return '/img/default_t-shirt.jpg'
      } else if (this.showData.productType === 'STANDARD_SWEATSHIRT-US') {
        return '/img/default_sweatshirt.jpg'
      } else if (this.showData.productType === 'STANDARD_PULLOVER_HOODIE-US') {
        return '/img/default_hoodie.jpg'
      }
    }
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    window.removeEventListener('dragenter', this.dragenterFunc)

    window.removeEventListener('dragleave', this.dragleaveFunc)

    window.removeEventListener('dragover', this.dragoverFunc)

    window.removeEventListener('drop', this.dropFunc)
  },
  methods: {
    debounce(func, wait, immediate) {
      let that = this
      return function() {
        var context = this,
          args = arguments
        var later = function() {
          that.debounceTimeout = null
          if (!immediate) func.apply(context, args)
        }
        var callNow = immediate && !that.debounceTimeout
        clearTimeout(that.debounceTimeout)
        that.debounceTimeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
      }
    },
    changeColor(checked, name) {
      this.saved = false
      if (this.showData.productType === 'STANDARD_TSHIRT-US') {
        this.colors[name].checked = checked
        if (checked) {
          if (this.selectedColors.length >= 10) {
            this.colors[this.selectedColors[9].hex].checked = false
            this.selectedColors.pop()
          }
          this.selectedColors.push(this.colors[name])
        } else {
          this.selectedColors = this.selectedColors.filter(
            color => color.checked
          )
        }
        this.showData.primaryColor = this.colors[name].name
      } else {
        this.w_colors[name].checked = checked
        if (checked) {
          // if (this.selectedColors.length >= 10) {
          //   this.w_colors[this.selectedColors[9].hex].checked = false;
          //   this.selectedColors.pop();
          // }
          this.selectedColors.push(this.w_colors[name])
        } else {
          this.selectedColors = this.selectedColors.filter(
            color => color.checked
          )
        }
        this.showData.primaryColor = this.w_colors[name].name
      }
    },
    findLinkMarkdown(raw) {
      let matches = raw.match(
        /(?:(?:https?|ftp):\/\/)(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?/gi
      )
      if (matches) {
        for (let i = 0; i < matches.length; i++) {
          let match = matches[i]
          let newFormattedLink = `***[${match.substring(
            0,
            43
          )}...](${match})***`
          if (match.startsWith('https://m.media-amazon.com/images/I/')) {
            newFormattedLink += ` **[[GET PNG]](https://m.media-amazon.com/images/I/${
              match.split('%7C')[2]
            })**`
          }
          raw = raw.replace(match, newFormattedLink)
        }
        // console.log("After edited: ", raw);
      }
      return raw
    },
    editRequirement() {
      this.editableRequirement = !this.editableRequirement
    },
    editNote() {
      this.editableNote = !this.editableNote
      if (!this.editableNote) {
        api({
          method: 'put',
          url: 'designs/' + this.showData.id,
          data: { note: this.showData.note }
        })
          .then(res => {
            this.$Message.success('Note saved!')
          })
          .catch(error => {
            this.$Message.error('Note save error: ' + error.message)
          })
      }
    },
    getKeywordsFromRequirement() {
      let requirement = this.showData.requirement
      if (requirement && requirement.includes('https://www.amazon.com')) {
        const regx = /(?<=dp\/)[A-Z0-9]+/gi
        const matches = requirement.match(regx)
        if (matches) {
          api({
            method: 'get',
            url: '/designs/fromamz',
            params: { url: 'https://www.amazon.com/dp/' + matches[0] }
          })
            .then(response => {
              if (this.showData.brand === '') {
                this.showData.brand = response.data.brand
              }
              if (this.showData.title === '') {
                this.showData.title = response.data.title
              }
              if (this.showData.kpf1 === '') {
                this.showData.kpf1 = response.data.kpf1
              }
              if (this.showData.kpf2 === '') {
                this.showData.kpf2 = response.data.kpf2
              }
            })
            .catch(error => {
              this.$Message.error(
                'Get data from amazon fail, please try again.'
              )
            })
        }
      }
    },
    clone() {
      let cloneData = JSON.parse(JSON.stringify(this.showData))
      delete cloneData.id
      cloneData.designUrl = ''
      delete cloneData.user
      if (cloneData.account) cloneData.account = cloneData.account.id
      if (cloneData.designer) cloneData.designer = cloneData.designer.id
      cloneData.designScore = 5
      api({
        method: 'post',
        url: '/designs',
        data: cloneData
      })
        .then(response => {
          // console.log(response);
          this.$emit('createcopy', response.data)
          this.$Message.success('Thêm thành công!')
        })
        .catch(error => {
          console.log(error)
          this.formDisabled = false
          this.$Message.error('Lỗi thêm vào server: ' + error.message)
        })
    },
    async saveData(updateData) {
      let isValid = true
      if (this.existTitle) {
        this.$Message.error('The same title already exists!')
        isValid = false
      }
      if (this.showData.designStatus === 'ready') {
        if (!this.showData.designUrl || this.showData.designUrl === '') {
          this.$Message.error('Invalid design image!')
          isValid = false
        } else if (this.showData.imgStatus !== 'confirmed') {
          this.$Message.error("Design's image is not confirmed!")
          isValid = false
        } else if (!this.showData.colors || this.showData.colors.length === 0) {
          this.$Message.error('Invalid colors!')
          isValid = false
        } else if (
          this.showData.productType === 'STANDARD_TSHIRT-US' &&
          (!this.showData.type || this.showData.type.length === 0)
        ) {
          this.$Message.error('Invalid types!')
          isValid = false
        } else if (!this.showData.price || isNaN(this.showData.price)) {
          this.$Message.error('Invalid price!')
          isValid = false
        } else if (!this.showData.brand || this.showData.brand === '') {
          this.$Message.error('Invalid brand!')
          isValid = false
        } else if (!this.showData.title || this.showData.title === '') {
          this.$Message.error('Invalid title!')
          isValid = false
        } else if (!this.showData.account) {
          this.$Message.error('Invalid account!')
          isValid = false
        }
      }
      if (isValid) {
        let newData
        if (!updateData) {
          this.showData.colors = this.selectedColors.map(color => {
            return color.name
          })

          newData = { ...this.showData }

          if (newData.account && newData.account.id) {
            newData.account = newData.account.id
          }
        } else {
          newData = updateData
          newData.id = this.showData.id
        }

        if (newData.title)
          newData.title = newData.title
            .replace(/[\u2018\u2019]/g, "'")
            .replace(/[\u201C\u201D]/g, '"')
        if (newData.brand)
          newData.brand = newData.brand
            .replace(/[\u2018\u2019]/g, "'")
            .replace(/[\u201C\u201D]/g, '"')
        if (newData.kpf1)
          newData.kpf1 = newData.kpf1
            .replace(/[\u2018\u2019]/g, "'")
            .replace(/[\u201C\u201D]/g, '"')
        if (newData.kpf2)
          newData.kpf2 = newData.kpf2
            .replace(/[\u2018\u2019]/g, "'")
            .replace(/[\u201C\u201D]/g, '"')

        // console.log('newData', newData, 'updateData', updateData)

        api({
          method: 'put',
          url: 'designs/' + newData.id,
          data: newData
        })
          .then(res => {
            if (res.data.account && typeof res.data.account == 'string') {
              for (let i = 0; i < this.accounts.length; i++) {
                if (this.accounts[i].id == res.data.account) {
                  this.showData.account = Object.assign({}, this.accounts[i])
                  break
                }
              }
            }
            this.showData.designUrl = 'somethingForUpdateView'
            this.showData.designUrl = res.data.designUrl
            this.showData.title = 'somethingForUpdateView'
            this.showData.title = res.data.title
            this.savedTitle = res.data.title
            // console.log(
            //   'Design saved!',
            //   res.data,
            //   'this.data',
            //   this.data,
            //   'this.showData',
            //   this.showData
            // )
            this.$emit('save', res.data)
            this.$Message.success('Design saved!')
            this.saved = true
          })
          .catch(error => {
            this.$Message.error('Design save error: ' + error.message)
          })
      } else {
        this.showData.designStatus = 'new'
      }
    },
    copyToClipboard(str) {
      const el = document.createElement('textarea') // Create a <textarea> element
      el.value = str // Set its value to the string that you want copied
      el.setAttribute('readonly', '') // Make it readonly to be tamper-proof
      el.style.position = 'absolute'
      el.style.left = '-9999px' // Move outside the screen to make it invisible
      document.body.appendChild(el) // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0 // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // Store selection if found
          : false // Mark as false to know no selection existed before
      el.select() // Select the <textarea> content
      document.execCommand('copy') // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el) // Remove the <textarea> element
      if (selected) {
        // If a selection existed before copying
        document.getSelection().removeAllRanges() // Unselect everything on the HTML document
        document.getSelection().addRange(selected) // Restore the original selection
      }
      this.$Message.success({
        content: 'Copy To Clipboard!',
        duration: 0.5
      })
    },
    fastSelectColor(type) {
      for (const key in this.colors) {
        this.colors[key].checked = false
      }
      this.selectedColors = []
      let listColor = []
      if (type == 'light') {
        listColor = [
          '#ffffff',
          '#8fb8db',
          '#5e9444',
          '#676c98',
          '#d7dbdc',
          '#f0e87b',
          '#f8a3bc',
          '#1c4086',
          '#cfd1d1',
          '#818189'
        ]
        this.showData.primaryColor = this.colors['#ffffff'].name
      }
      if (type == 'dark') {
        listColor = [
          '#000000',
          '#3f3e3c',
          '#31261d',
          '#6e0a25',
          '#4f5555',
          '#676c98',
          '#15232b',
          '#4a4f26',
          '#1c4086',
          '#818189'
        ]
        this.showData.primaryColor = this.colors['#000000'].name
      }
      for (let i = 0; i < listColor.length; i++) {
        this.colors[listColor[i]].checked = true
        this.selectedColors.push(this.colors[listColor[i]])
      }
      this.saved = false
    },
    getDimensions(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader()

        reader.readAsDataURL(file)
        reader.onload = evt => {
          // console.log(evt);
          let img = new Image()
          img.onload = () => {
            // console.log('getDimensions', {
            //   width: img.width,
            //   height: img.height
            // })
            resolve({ width: img.width, height: img.height })
          }
          img.src = evt.target.result
          // resolve({ width: 0, height: 0 });
        }

        reader.onerror = err => {
          console.error(err)
          reject(err)
        }
      })
    },
    async uploadFiles(f) {
      if (f.length > 1) {
        alert('Only one file!')
        return
      }

      if (f[0].type !== 'image/png') {
        alert('PNG!')
        return
      }

      if (
        f[0].name !==
        this.showData.category +
          '_' +
          this.showData.number +
          (this.showData.cloneNumber ? '_' + this.showData.cloneNumber : '') +
          '.png'
      ) {
        alert('PNG not match name!')
        return
      }

      // console.log('File', f[0])

      try {
        let dimensions = await this.getDimensions(f[0])
        if (
          this.showData.productType === 'STANDARD_TSHIRT-US' ||
          this.showData.productType === 'STANDARD_SWEATSHIRT-US'
        ) {
          if (dimensions.width != 4500 || dimensions.height != 5400) {
            alert('Dimensions must be 4500x5400px!')
            return
          }
        }
        if (this.showData.productType === 'STANDARD_PULLOVER_HOODIE-US') {
          if (dimensions.width != 4500 || dimensions.height != 4050) {
            alert('Dimensions must be 4500x4050px!')
            return
          }
        }
      } catch (error) {
        alert('Load image failed!')
        console.log('GET getDimensions ERROR', error)
        return
      }

      let formData = new FormData()
      formData.append('file', f[0])
      formData.append(
        'name',
        this.showData.category +
          '_' +
          this.showData.number +
          (this.showData.cloneNumber ? '_' + this.showData.cloneNumber : '') +
          '.png'
      )
      // console.log('>> formData >> ', formData)
      this.$Loading.start()
      // You should have a server side REST API
      api({
        method: 'post',
        url: 'drive',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 0,
        // data: {
        //   name:
        //     this.showData.category + "_" + this.showData.number + ".png",
        //   bufferArr: bufferArr
        // }
        data: formData
      })
        .then(res => {
          // console.log('upload file res.data', res.data)
          this.showData.designUrl = res.data.designUrl
          this.showData.thumbnailImg = res.data.thumbnailImg
          this.showData.previewImg = res.data.previewImg
          this.showData.imgStatus = res.data.imgStatus
          this.showData.designStatus = res.data.designStatus
          this.$emit('save', this.showData)
          this.$Loading.finish()
          this.$Message.success('Upload to Drive OK! ')
        })
        .catch(err => {
          console.log(err)
          this.$Loading.error()
          this.$Message.error('Upload to drive error: ' + err.message)
        })
    },
    dragenterFunc(e) {
      document.querySelector('#dropzone').style.visibility = ''
      document.querySelector('#dropzone').style.opacity = 1
      document.querySelector('#textnode').style.fontSize = '48px'
    },
    dragleaveFunc(e) {
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = 'hidden'
      document.querySelector('#dropzone').style.opacity = 0
      document.querySelector('#textnode').style.fontSize = '42px'
    },
    dragoverFunc(e) {
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = ''
      document.querySelector('#dropzone').style.opacity = 1
      document.querySelector('#textnode').style.fontSize = '48px'
    },
    dropFunc(e) {
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = 'hidden'
      document.querySelector('#dropzone').style.opacity = 0
      document.querySelector('#textnode').style.fontSize = '42px'

      var files = e.dataTransfer.files
      // console.log('Drop files:', files)
      //this.uploadFile(files);
      this.uploadFiles(files)
    },
    validateKeywords(fieldCheck) {
      if (fieldCheck === 'title') {
        this.errorTitle = false
        this.existTitle = false
        this.titleErrorMessage = ''
        if (this.showData.title != '') {
          if (this.showData.title !== this.savedTitle) {
            api({
              method: 'get',
              url: '/designs/exist',
              params: { title: this.showData.title }
            })
              .then(response => {
                if (response.data.exist) {
                  this.titleErrorMessage = '* This title already exists!'
                  this.errorTitle = true
                  this.existTitle = true
                }
              })
              .catch(error => {
                // this.$Message.error('Check keywords failed: ' + error.message)
              })
          }

          api({
            method: 'get',
            url: '/designs/checktm',
            params: { text: this.showData.title }
          })
            .then(response => {
              this.titleTM = response.data
              if (response.data && response.data.length !== 0) {
                this.titleErrorMessage +=
                  '* This title has trademark keyword(s): '
                this.errorTitle = true
              } else {
                this.titleErrorMessage +=
                  '* This title has NO trademark keywords.'
                this.errorTitle = true
              }
            })
            .catch(error => {
              // this.$Message.error('Check keywords failed: ' + error.message)
            })
        }
      } else if (fieldCheck === 'brand') {
        if (this.showData.brand === '') {
          this.errorBrand = false
        } else {
          api({
            method: 'get',
            url: '/designs/checktm',
            params: { text: this.showData.brand }
          })
            .then(response => {
              this.brandTM = response.data
              if (response.data && response.data.length !== 0) {
                this.brandErrorMessage =
                  '* This brand has trademark keyword(s): '
                this.errorBrand = true
              } else {
                this.brandErrorMessage = '* This brand has NO trademark keyword'
                this.errorBrand = true
              }
            })
            .catch(error => {
              // this.$Message.error('Check keywords failed: ' + error.message)
            })
        }
      } else if (fieldCheck === 'kpf1') {
        if (this.showData.kpf1 === '') {
          this.errorKpf1 = false
        } else {
          api({
            method: 'get',
            url: '/designs/checktm',
            params: { text: this.showData.kpf1 }
          })
            .then(response => {
              this.kpf1TM = response.data
              if (response.data && response.data.length !== 0) {
                this.kpf1ErrorMessage = '* This kpf has trademark keyword(s): '
                this.errorKpf1 = true
              } else {
                this.kpf1ErrorMessage = '* This kpf has NO trademark keyword'
                this.errorKpf1 = true
              }
            })
            .catch(error => {
              // this.$Message.error('Check keywords failed: ' + error.message)
            })
        }
      } else if (fieldCheck === 'kpf2') {
        if (this.showData.kpf2 === '') {
          this.errorKpf2 = false
        } else {
          api({
            method: 'get',
            url: '/designs/checktm',
            params: { text: this.showData.kpf2 }
          })
            .then(response => {
              this.kpf2TM = response.data
              if (response.data && response.data.length !== 0) {
                this.kpf2ErrorMessage = '* This kpf has trademark keyword(s): '
                this.errorKpf2 = true
              } else {
                this.kpf2ErrorMessage = '* This kpf has NO trademark keyword'
                this.errorKpf2 = true
              }
            })
            .catch(error => {
              // this.$Message.error('Check keywords failed: ' + error.message)
            })
        }
      }
    }
  },
  watch: {}
}
</script>

<style>
div#dropzone {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 175ms, opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  font: bold 42px Oswald, DejaVu Sans, Tahoma, sans-serif;
}
div#textnode {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  transition: font-size 175ms;
}
.error-message {
  color: red;
  font-style: italic;
}
</style>
